import React, { Component } from "react";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

class TotalCharge extends Component {
  calculateDeliveyCharge = (deliveryCharge) => {
    let charge = deliveryCharge;

    if (
      this.props.applied_promo &&
      this.props.applied_promo.discount_type === "delivery"
    ) {
      charge = 0;
    } else if (this.props.discounts.delivery.length) {
      charge =
        charge -
        charge *
          ((this.props.discounts.delivery[0].discount_amount || 100) / 100);
    }
    return charge;
  };

  render() {
    const { language, settings, showPromoProgressBar, loyaltyPointConvert } =
      this.props;
    const { custom_texts } = settings;

    const currency =
      language == "english"
        ? settings.currency_english
        : settings.currency_local;
    const checkVatIncludedWithProduct =
      settings.enable_vat_with_product_price &&
      settings.enable_vat &&
      settings.enable_vat_staff &&
      settings.vat_rate > 0;

    const checkForGiftingWrapping =
      settings.enable_gifts &&
      settings.enable_gifts_staff &&
      settings.enable_gift_wrapping &&
      settings.gift_wrapping_price > 0 &&
      this.props.promise.isGift === true &&
      this.props.promise.gift_wrapping === true;

    let deliveryCharge = this.calculateDeliveyCharge(this.props.deliveryPrice);

    let subTotal = this.props.subtotal;

    let height = 95 + 25; // The +25 is for subtotal
    // if (this.props.showDelivery) height += 25;
    // if (this.props.discount > 0) {
    //   height += 25;
    // }
    // if (
    //   this.props.settings.additional_fee > 0 &&
    //   this.props.settings.enable_additional_fee &&
    //   !OfflinePaymentsMethods.includes(this.props.method) &&
    //   this.props.method !== "none"
    // ) {
    //   height += 25;
    // }
    // if (
    //   settings.enable_vat &&
    //   settings.enable_vat_staff &&
    //   settings.vat_rate > 0
    // ) {
    //   height += 25;
    //   if (checkVatIncludedWithProduct) height += 25;
    // }
    // if (checkForGiftingWrapping) {
    //   height += 25;
    // }
    // if (custom_texts.delivery_fee_text.length > 30 && language === "english") {
    //   height += 25;
    // }
    // if (
    //   custom_texts.delivery_fee_text_ar.length > 30 &&
    //   language === "arabic"
    // ) {
    //   height += 25;
    // }
    const currencyIcon = getCurrencyIcon(settings);

    const checkLoyaltyPoint =
      loyaltyPointConvert > 0 &&
      this.props.useCustomerPoints &&
      this.props.settings.enable_loyalty_points_staff &&
      this.props.settings.enable_loyalty_points &&
      this.props.settings.enable_loyalty_points_payment;

    const calculateGrossAmount = (totalForVat, vatAmount) => {
      const vat = vatAmount || 0;
      return vat > 0 ? Math.max(totalForVat - vat, 0) : totalForVat;
    };
    return (
      <div
        className="py-2 border-top totalCharge-english"
        style={{
          position: "fixed",
          width: "100%",
          bottom: showPromoProgressBar
            ? 120
            : settings.enable_loyalty_points_page && window.outerWidth < 768
              ? 100
              : 55,
          backgroundColor: "white",
        }}
      >
        <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
          <div className="col">
            <p
              className={"mb-0 ".concat(
                language == "english" ? "float-left ml-4" : "float-right mr-4",
              )}
              style={{ fontSize: 16 }}
            >
              {window.location.hostname?.includes("generalassembly.ordable.com")
                ? "Talent"
                : language == "english"
                  ? "Subtotal"
                  : "الإجمالي"}
            </p>
          </div>

          <div className="col">
            <p
              className={"mb-0 ".concat(
                language == "english" ? "float-right mr-4" : "float-left ml-4",
              )}
              style={{ fontSize: 16 }}
            >
              <span className={currencyIcon}>
                {subTotal.toFixed(settings.currency_decimals)} {currency}
              </span>
            </p>
          </div>
        </div>

        {this.props.showDelivery && (
          <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
            <div
              className="col-8"
              style={{
                display: "flex",
                // overflow: "hidden",
                // textOverflow: "ellipsis",
                // whiteSpace: "nowrap",
              }}
            >
              <p
                className={"mb-0 ".concat(
                  language == "english"
                    ? "float-left ml-4"
                    : "float-right mr-4",
                )}
                style={{
                  fontSize: 16,
                  // overflow: "hidden",
                  // textOverflow: "ellipsis",
                  // whiteSpace: "nowrap",
                  textAlign: language === "english" ? "left" : "right",
                }}
              >
                {language == "english"
                  ? custom_texts.delivery_fee_text
                  : custom_texts.delivery_fee_text_ar}
              </p>
            </div>

            <div className="col">
              <p
                className={"mb-0 ".concat(
                  language == "english"
                    ? "float-right mr-4"
                    : "float-left ml-4",
                )}
                style={{ fontSize: 16 }}
              >
                {this.props.isInternationalDelivery ? (
                  this.props.shipping.loading ? (
                    <span>
                      <CircularProgress
                        color="primary"
                        style={{
                          width: 10,
                          height: 10,
                          marginRight: language == "english" && 5,
                          marginLeft: language == "arabic" && 5,
                        }}
                      />{" "}
                    </span>
                  ) : this.props.shipping.data &&
                    this.props.shipping.data.result &&
                    this.props.shipping.data.data ? (
                    <span className={currencyIcon}>
                      {parseFloat(
                        this.props.shipping.data.data.quote_data
                          .shipping_charge,
                      ).toFixed(settings.currency_decimals)}{" "}
                      {currency}
                    </span>
                  ) : this.props.shipping.data &&
                    this.props.shipping.data.HasErrors === false &&
                    this.props.aramex_error === false &&
                    this.props.shipping.data.total_value > 0 ? (
                    <span className={currencyIcon}>
                      {parseFloat(this.props.shipping.data.total_value).toFixed(
                        settings.currency_decimals,
                      )}{" "}
                      {currency}
                    </span>
                  ) : (
                    <div style={{ display: "flex" }}>
                      {this.props.deliveryPrice !== deliveryCharge && (
                        <span
                          style={{ textDecoration: "line-through" }}
                          className={`mx-2 ${currencyIcon}`}
                        >
                          {this.props.deliveryPrice.toFixed(
                            settings.currency_decimals,
                          )}{" "}
                          {currency}{" "}
                        </span>
                      )}
                      <span className={currencyIcon}>
                        {deliveryCharge.toFixed(settings.currency_decimals)}{" "}
                        {currency}
                      </span>
                    </div>
                  )
                ) : (
                  <div style={{ display: "flex" }}>
                    {this.props.deliveryPrice !== deliveryCharge && (
                      <span
                        style={{ textDecoration: "line-through" }}
                        className={`mx-2 ${currencyIcon}`}
                      >
                        {this.props.deliveryPrice.toFixed(
                          settings.currency_decimals,
                        )}{" "}
                        {currency}{" "}
                      </span>
                    )}
                    <span className={currencyIcon}>
                      {deliveryCharge.toFixed(settings.currency_decimals)}{" "}
                      {currency}
                    </span>
                  </div>
                )}
              </p>
            </div>
          </div>
        )}
        {checkForGiftingWrapping && (
          <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
            <div className="col">
              <p
                className={
                  language == "english" ? "float-left ml-4" : "float-right mr-4"
                }
                style={{ fontSize: 16 }}
              >
                {language == "english" ? "Gift Wrapping" : "تغليف الهدايا"}
              </p>
            </div>
            <div className="col">
              <p
                style={{ fontSize: 16 }}
                className={`${
                  language === "english"
                    ? "float-right mr-4"
                    : "float-left ml-4"
                } ${currencyIcon}`}
              >
                {parseFloat(settings.gift_wrapping_price).toFixed(
                  settings.currency_decimals,
                )}{" "}
                {currency}
              </p>
            </div>
          </div>
        )}
        {this.props.discount > 0 && (
          <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
            <div className="col">
              <p
                className={
                  language == "english" ? "float-left ml-4" : "float-right mr-4"
                }
                style={{ fontSize: 16 }}
              >
                {language == "english" ? "Discount" : "الخصم"}
              </p>
            </div>
            <div className="col">
              <p
                className={`${
                  language === "english"
                    ? "float-right mr-4"
                    : "float-left ml-4"
                } ${currencyIcon}`}
                style={{ fontSize: 16 }}
              >
                {checkVatIncludedWithProduct
                  ? `${settings?.currency_iso === "SAR" ? "" : "-"} ${(this
                      .props.excludeVat
                      ? this.props.discountWithoutVatItems
                      : this.props.discount
                    ).toFixed(settings.currency_decimals)}
                ${currency}`
                  : `${
                      settings?.currency_iso === "SAR" ? "" : "-"
                    }  ${this.props.discount.toFixed(
                      settings.currency_decimals,
                    )}
                ${currency}`}
              </p>
            </div>
          </div>
        )}
        {checkLoyaltyPoint && (
          <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
            <div className="col">
              <p
                className={
                  language == "english" ? "float-left ml-4" : "float-right mr-4"
                }
                style={{ fontSize: 16 }}
              >
                {language == "english" ? "Loyalty Points" : "نقاط الولاء"}
              </p>
            </div>
            <div className="col">
              <p
                className={`${
                  language === "english"
                    ? "float-right mr-4"
                    : "float-left ml-4"
                } ${currencyIcon}`}
                style={{ fontSize: 16 }}
              >
                {`${
                  settings?.currency_iso === "SAR" ? "" : "-"
                }  ${this.props.loyaltyPointConvert.toFixed(
                  settings.currency_decimals,
                )}
                ${currency}`}
              </p>
            </div>
          </div>
        )}
        {settings.additional_fee > 0 &&
          settings.enable_additional_fee &&
          this.props.method !== "none" && (
            <div
              className="row mb-1"
              dir={language == "english" ? "ltr" : "rtl"}
            >
              <div className="col">
                <p
                  className={
                    language == "english"
                      ? "float-left ml-4"
                      : "float-right mr-4"
                  }
                  style={{ fontSize: 16 }}
                >
                  {language == "english"
                    ? custom_texts.additional_fee
                    : custom_texts.additional_fee_ar}
                </p>
              </div>
              <div className="col">
                <p
                  className={`${
                    language === "english"
                      ? "float-right mr-4"
                      : "float-left ml-4"
                  } ${currencyIcon}`}
                  style={{ fontSize: 16 }}
                >
                  {`${parseFloat(settings.additional_fee).toFixed(
                    3,
                  )} ${currency}`}
                </p>
              </div>
            </div>
          )}
        {checkVatIncludedWithProduct && (
          <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
            <div className="col">
              <p
                className={
                  language == "english" ? "float-left ml-4" : "float-right mr-4"
                }
                style={{ fontSize: 16 }}
              >
                {language === "english" ? "Gross Amount" : "المبلغ الإجمالي"}
              </p>
            </div>
            <div className="col">
              <p
                className={`${
                  language === "english"
                    ? "float-right mr-4"
                    : "float-left ml-4"
                } ${currencyIcon}`}
                style={{ fontSize: 16 }}
              >
                {parseFloat(
                  parseFloat(calculateGrossAmount(this.props.total,this.props.vat)),
                ).toFixed(settings.currency_decimals)}{" "}
                {currency}
              </p>
            </div>
          </div>
        )}
        {settings.enable_vat &&
          settings.enable_vat_staff &&
          settings.vat_rate > 0 && (
            <div
              className="row mb-1"
              dir={language == "english" ? "ltr" : "rtl"}
            >
              <div className="col">
                <p
                  className={
                    language == "english"
                      ? "float-left ml-4"
                      : "float-right mr-4"
                  }
                  style={{ fontSize: 16 }}
                >
                  {language == "english" ? "VAT" : "ضرائب"}
                </p>
              </div>
              <div className="col">
                <p
                  className={`${
                    language === "english"
                      ? "float-right mr-4"
                      : "float-left ml-4"
                  } ${currencyIcon}`}
                  style={{ fontSize: 16 }}
                >
                  {`${this.props.vat}
                ${currency}`}
                </p>
              </div>
            </div>
          )}

        <div className="row" dir={language == "english" ? "ltr" : "rtl"}>
          <div className="col">
            <p
              className={
                language == "english" ? "float-left ml-4" : "float-right mr-4"
              }
              style={{ fontSize: 16, fontWeight: 600 }}
            >
              {window.location.hostname?.includes("generalassembly.ordable.com")
                ? "Talent"
                : language == "english"
                  ? "Total"
                  : "المجموع"}
            </p>
          </div>
          <div className="col">
            <p
              className={`${
                language === "english" ? "float-right mr-4" : "float-left ml-4"
              } ${currencyIcon}`}
              style={{ fontSize: 16, fontWeight: 600 }}
            >
              {checkVatIncludedWithProduct ? (
                <>
                  {parseFloat(parseFloat(this.props.total)).toFixed(
                    settings.currency_decimals,
                  )}{" "}
                  {currency}
                </>
              ) : (
                <>
                  {parseFloat(
                    parseFloat(this.props.total) + parseFloat(this.props.vat),
                  ).toFixed(settings.currency_decimals)}{" "}
                  {currency}
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    applied_promo: state.cart.promos,
    discounts: state.cart.discounts,
    settings: state.store.store.settings,
    shipping: state.shipping,
    cart: state.cart.cart,
    aramex_error: state.shipping.aramex_error,

    promise: state.promise,
  };
};

export default connect(mapStateToProps)(TotalCharge);
